import { BaseContentType } from '@models/Content';
import { TitleType } from '@models/Title';

export const TitleColorMap: Record<TitleType, BaseContentType> = {
  episode: 'menu',
  movie: 'collection',
  program: 'link',
  series: 'unmanaged',
};
